import { Navigate, createBrowserRouter } from 'react-router-dom';
import Auth from './pages/Auth';
import AuthEmail from './pages/AuthEmail';
import AuthVerify from './pages/AuthVerify';
import AuthCallback from './pages/AuthCallback';
import AuthReset from './pages/AuthReset';
import OnboardingFlow from './pages/onboarding/OnboardingFlow';
import ArticleList from './features/articles/ArticleList';
import ArticleBody from './features/articles/ArticleBody';
import VocabList from './features/vocab/VocabList';
import ProtectedLayout from './layouts/ProtectedLayout';
import OnboardedLayout from './layouts/OnboardedLayout';

// Enable OAuth listener for proper OAuth handling
import 'aws-amplify/auth/enable-oauth-listener';

export const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/articles" replace /> },
  { path: '/auth', element: <Auth /> },
  { path: '/auth/email', element: <AuthEmail /> },
  { path: '/auth/verify', element: <AuthVerify /> },
  { path: '/auth/callback', element: <AuthCallback /> },
  { path: '/auth/reset', element: <AuthReset /> },
  {
    element: <ProtectedLayout />,
    children: [
      { path: '/onboarding', element: <OnboardingFlow /> },
      {
        element: <OnboardedLayout />,
        children: [
          { path: '/articles', element: <ArticleList /> },
          { path: '/articles/:articleId', element: <ArticleBody /> },
          { path: '/vocab', element: <VocabList /> },
        ],
      },
    ],
  },
]);
